import React from "react";

// eslint-disable-next-line no-unused-vars
const ContextMenuItems = ({ record, visible, x, y }) =>
  visible && (
    <ul className="popup" style={{ left: `${x - 80}px`, top: `${y - 80}px` }}>
      <li id="Delete">Delete Row</li>
      <li id="Autosize">Autosize All Columns</li>
      <li id="Reset">Reset Columns</li>
      <li id="Copy">Copy</li>
    </ul>
  );

export default ContextMenuItems;



// WEBPACK FOOTER //
// ./src/commonComponents/ContextMenuItems/ContextMenuItems.js